import React from 'react';
import { useParams } from 'react-router';
import { useCast } from '../../../chromecast/hooks/use-cast';
import { useSearchParams } from '../../../routes/utils/use-search-params';
import { ErrorBoundary } from '../../error-boundary';
import { ChromecastVodSenderLoader } from './chromecast-vod-sender/chromecast-vod-sender-loader';
import { ClientPlayerLoader } from './client-player/client-player-loader';
import { PlayerErrorFallback } from './player-error-fallback/player-error-fallback';
import '../styles/ats-player.scss';
import { ScriptService } from '../../../controllers/ScriptService';
import Header from '../../../views/app/Header';
import { HeaderDisplayType, HeaderInteractionType } from '../../../interfaces';
import MobileLock from '../../../views/app/MobileLock';

export function AtsPlayer() {
  const { platformTitleId } = useParams<{ platformTitleId: string }>();
  const search = useSearchParams();

  const cast = useCast();

  const position = search.get('position');
  const positionAsNumber = position ? parseInt(position, 10) : undefined;

  const castMediaPosition = cast.media !== undefined ? cast.media.getEstimatedTime() : undefined;

  if (ScriptService.onMobile()) {
    const deepLink = 'altibox://';
    return (
      <div className="main-frame">
        <Header displayType={HeaderDisplayType.NoStickyGradient} interactionType={HeaderInteractionType.CloseOnly} />
        <MobileLock deepLink={deepLink} /> :
      </div>
    );
  }

  const providerIdentifier = search.get('provider');

  if (cast.sessionStatus === 'connected' && cast.session !== undefined) {
    return (
      <ErrorBoundary fallback={(props) => <PlayerErrorFallback {...props} />}>
        <ChromecastVodSenderLoader
          session={cast.session}
          platformTitleId={platformTitleId}
          providerIdentifier={providerIdentifier}
          position={positionAsNumber}
        />
      </ErrorBoundary>
    );
  }

  const masterId = search.get('masterId');

  return (
    <ErrorBoundary fallback={(props) => <PlayerErrorFallback {...props} />}>
      <ClientPlayerLoader
        masterId={masterId}
        platformTitleId={platformTitleId}
        providerIdentifier={providerIdentifier}
        position={castMediaPosition ?? positionAsNumber}
      />
    </ErrorBoundary>
  );
}
